import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/category/romance', label: '分类' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 h-[72px] flex items-center bg-white/95 backdrop-blur-md border-b border-background-200/60">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between">
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`relative text-[15px] font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                location.pathname === link.to || (link.to !== '/' && location.pathname.startsWith(link.to))
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              {link.label}
              {(location.pathname === link.to || (link.to !== '/' && location.pathname.startsWith(link.to))) && (
                <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-primary-500" />
              )}
            </Link>
          ))}
        </div>

        <Link to="/" className="flex items-center gap-2 cursor-pointer group">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-heart-3-fill text-primary-500 text-2xl" style={{ width: '32px', height: '32px' }} />
          </div>
          <span className="font-display text-xl text-foreground-900 group-hover:text-primary-500 transition-colors">
            桃桃漫画网
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-5">
          <button className="w-9 h-9 flex items-center justify-center text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
            <i className="ri-search-line text-xl" style={{ width: '20px', height: '20px' }} />
          </button>
          <button className="w-9 h-9 flex items-center justify-center text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
            <i className="ri-user-line text-xl" style={{ width: '20px', height: '20px' }} />
          </button>
          <Link
            to="/category/romance"
            className="h-[44px] px-6 flex items-center gap-2 bg-primary-500 text-white rounded-full text-[14px] font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            开始阅读
            <i className="ri-arrow-right-line" style={{ width: '16px', height: '16px' }} />
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={`text-2xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} style={{ width: '24px', height: '24px' }} />
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden absolute top-[72px] left-0 right-0 bg-white border-b border-background-200/60 py-6 px-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={() => setMobileOpen(false)}
              className={`text-[15px] font-medium whitespace-nowrap transition-colors cursor-pointer ${
                location.pathname === link.to || (link.to !== '/' && location.pathname.startsWith(link.to))
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/category/romance"
            onClick={() => setMobileOpen(false)}
            className="h-[44px] px-6 flex items-center justify-center gap-2 bg-primary-500 text-white rounded-full text-[14px] font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer w-fit"
          >
            开始阅读
            <i className="ri-arrow-right-line" style={{ width: '16px', height: '16px' }} />
          </Link>
        </div>
      )}
    </nav>
  );
}